import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _Typography;
var _excluded = ["className", "children", "label", "labelPosition", "margin", "fullWidth", "required", "wrap"];
import React from 'react';
import PropTypes from 'prop-types';
import { classNamePropTypes, addClassNames } from '../customPropTypes/classNames';
import { addSpacingClasses, marginPropTypes } from '../customPropTypes/spacing';
import Typography from '../Typography/Typography';
import Group from '../Group/Group';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var labelProps = {
  top: {
    direction: 'column',
    gap: 'xs',
    align: 'initial'
  },
  bottom: {
    direction: 'column-reverse',
    gap: 'xs',
    align: 'initial'
  },
  left: {
    direction: 'row',
    gap: 'sm',
    valign: 'center',
    align: 'initial',
    wrap: false
  },
  right: {
    direction: 'row-reverse',
    gap: 'sm',
    align: 'end',
    valign: 'center',
    wrap: false
  }
};
var typographyProps = {
  top: {
    size: 'sm',
    weight: 'bold'
  },
  bottom: {
    size: 'sm',
    weight: 'bold'
  },
  left: {
    size: 'md'
  },
  right: {
    size: 'md'
  }
};
function FormLabel(_ref) {
  var className = _ref.className,
    children = _ref.children,
    label = _ref.label,
    labelPosition = _ref.labelPosition,
    margin = _ref.margin,
    fullWidth = _ref.fullWidth,
    required = _ref.required,
    wrap = _ref.wrap,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var cssClasses = ['st_label', "st_label--".concat(labelPosition)];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin: margin,
    cssClasses: cssClasses
  });
  if (fullWidth) cssClasses.push('st_label--fullWidth');
  return (
    /*#__PURE__*/
    /* eslint-disable-next-line jsx-a11y/label-has-associated-control */
    _jsxs(Group, _extends({
      componentEl: "label"
    }, labelProps[labelPosition], {
      className: cssClasses.join(' ')
    }, otherProps, {
      children: [" ", /*#__PURE__*/_jsxs(Typography, _extends({}, typographyProps[labelPosition], {
        whiteSpace: wrap === false ? 'nowrap' : null,
        children: [label, required && (_Typography || (_Typography = /*#__PURE__*/_jsx(Typography, {
          color: "lava",
          inline: true,
          children: " *"
        })))]
      })), children]
    }))
  );
}
process.env.NODE_ENV !== "production" ? FormLabel.propTypes = {
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** what to display as the label content */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /** position of label relative to input */
  labelPosition: PropTypes.oneOf(['top', 'left', 'right', 'bottom']),
  /** margin for label, if any */
  margin: marginPropTypes,
  /** whether label should take up all available space */
  fullWidth: PropTypes.bool,
  /** whether this is for a required input, will add a visual marker to the label */
  required: PropTypes.bool,
  /** whether to allow text to wrap or force to always be on one line */
  wrap: PropTypes.bool
} : void 0;
FormLabel.defaultProps = {
  className: null,
  labelPosition: 'top',
  margin: null,
  fullWidth: false,
  required: false,
  wrap: false
};
export default FormLabel;